import React from 'react';
import { setClassNames } from '@ddc/classnames-js';
import {
	useLabels,
	usePrefs,
	useSitemap,
	useRequestData
} from 'wsm-common-data';
import trackEvent from '../utils/trackEvent';

const AdChoices = () => {
	const labels = useLabels();
	const { windowId } = useRequestData();
	const { adChoicesClasses, showAdChoices, adChoicesPage } = usePrefs();
	const sitemap = useSitemap();

	if (showAdChoices === 'false') return null;

	const isAbsoluteUrl = adChoicesPage && /^https?:\/\//i.test(adChoicesPage);

	// Resolve URL from alias or use direct URL, with 404 page as fallback
	const resolvedUrl = isAbsoluteUrl
		? adChoicesPage
		: sitemap.get(adChoicesPage) || '/404.htm';

	const isExternalLink = /^https?:\/\//i.test(resolvedUrl);

	return (
		<a
			href={resolvedUrl}
			{...(isExternalLink
				? { target: '_blank', rel: 'noopener noreferrer' }
				: {})}
			className={setClassNames([
				'adchoices',
				'text-black',
				'line-height-reset',
				'd-flex',
				'align-items-center',
				...adChoicesClasses.split(' ')
			])}
			onClick={() => {
				trackEvent('Ad Choices', windowId);
			}}
		>
			{labels.get('ADCHOICES')}
			<img
				className="d-inline"
				width="11"
				height="11"
				aria-hidden
				alt=""
				src="https://images.dealer.com/ddc/adchoices/logo.svg"
			/>
		</a>
	);
};

export default AdChoices;
